__turbopack_context__.v({
  "clearButton": "SearchInput-module__GV4HbG__clearButton",
  "root": "SearchInput-module__GV4HbG__root",
});
